module.exports = "/_next/static/images/careerImage-2x-7d54a6b149303de1d0f5101b84e57f58.jpg.webp";